import React from 'react'
import { fadedBlack2, themeColor, white } from '@edulastic/colors'
import { TokenStorage } from '@edulastic/api'
import ReactJoyride from 'react-joyride'
import _ from 'lodash'

const VARIANT_OVERLAY = {
  aggressive: {
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
  },
  moderate: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
}

const EduJoyride = ({
  styles,
  variant,
  hideCloseButton,
  disableOverlay,
  disableCloseOnEsc,
  ...props
}) => {
  // Disable every joyride while proxying another user (unless the admin opted out).
  if (TokenStorage.isJoyrideDisabledForProxy()) {
    return null
  }

  const isAggressive = variant === 'aggressive'
  const isModerate = variant === 'moderate'
  const resolvedHideCloseButton =
    hideCloseButton !== undefined ? hideCloseButton : isAggressive
  const resolvedDisableOverlay =
    disableOverlay !== undefined ? disableOverlay : isModerate
  const resolvedDisableCloseOnEsc =
    disableCloseOnEsc !== undefined ? disableCloseOnEsc : isAggressive

  const options = {
    arrowColor: white,
    backgroundColor: white,
    beaconSize: 36,
    overlayColor: isAggressive ? 'rgba(0, 0, 0, 0.65)' : 'rgba(0, 0, 0, 0.5)',
    primaryColor: themeColor,
    spotlightShadow: isModerate ? 'none' : '0 0 15px rgba(0, 0, 0, 0.5)',
    textColor: fadedBlack2,
    width: 246,
    zIndex: 1000,
    ...(props.options || {}),
  }

  const buttonBase = {
    backgroundColor: 'transparent',
    border: 0,
    borderRadius: 0,
    color: themeColor,
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
    padding: 8,
    WebkitAppearance: 'none',
  }

  const variantOverlayStyles =
    variant && VARIANT_OVERLAY[variant] && !resolvedDisableOverlay
      ? { overlay: VARIANT_OVERLAY[variant] }
      : {}

  return (
    <>
      <ReactJoyride
        styles={_.merge(
          {
            options,
            buttonNext: buttonBase,
            buttonBack: {
              ...buttonBase,
              marginRight: '6rem',
            },
            buttonSkip: {
              display: 'none',
            },
            tooltipTitle: {
              fontSize: 14,
              fontWeight: 400,
              textAlign: 'left',
              margin: 0,
            },
            tooltipContent: {
              fontSize: 12,
              fontWeight: 400,
              textAlign: 'left',
              margin: 0,
              padding: 0,
              paddingTop: '8px',
            },
            ...variantOverlayStyles,
          },
          styles
        )}
        disableOverlay={resolvedDisableOverlay}
        disableOverlayClose
        disableCloseOnEsc={resolvedDisableCloseOnEsc}
        hideCloseButton={resolvedHideCloseButton}
        locale={{
          back: 'Back',
          close: 'Close',
          last: 'Done',
          next: 'Next',
          open: 'Open the dialog',
          skip: 'Skip',
          ...(props.locale || {}),
        }}
        {...props}
      />
    </>
  )
}

export default EduJoyride
